import React from "react"
import { canAll, canAny } from "./ability"
import { TPermission } from "./permissions"
import { useAbility } from "../components/context/AbilityContext"
import NotAuthorized from "../components/common/NotAuthorized"

export type AuthorizedProps = {
    anyOf?: TPermission[]
    allOf?: TPermission[]
    page?: boolean
    children?: React.ReactNode
}

/** Rechteprüfung für Seiten und Elemente; ohne Recht `<NotAuthorized/>` (page) oder nichts. */
export const Authorized = ({ anyOf, allOf, page, children }: AuthorizedProps) => {
    const ability = useAbility()
    const isAuthorized = canAll(ability, allOf ?? []) && canAny(ability, anyOf ?? [])
    if (isAuthorized) return <>{children}</>
    return page ? <NotAuthorized /> : null
}
